export default __webpack_public_path__ + "static/media/LironHadad.06dabd57.webp";